<template>
<div>
  <mainBar></mainBar>

  <div class="container-fluid home">
    <div class="row">
        <div class="col-sm-2">
          <tutorialPicker :workbenchWrapper="workbenchWrapper"></tutorialPicker>
        </div>
        <div class="col-sm-10">
          <workbench ref="workbench"></workbench>
        </div>
    </div>    
  </div>

  <modalMessage></modalMessage>
</div>
</template>

<script>
import workbench from 'components/workbench/Workbench'
import tutorialPicker from 'components/tutorialPicker/TutorialPicker'
import logo from 'components/utils/Logo'
import modalMessage from 'components/utils/modalMessage/ModalMessage'
import mainBar from 'components/MainBar'

export default {
  name: 'hello',
  data () {
    let self = this;
    return {
      workbenchWrapper: {
        getWorkbench() { return self.$refs.workbench }
      }
    }
  },
  components:{
     workbench,
     tutorialPicker,
     logo,
     modalMessage,
     mainBar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Home.vue?47ecf808